import { z } from 'zod';
/** Header used to identify one logical state-changing operation across retries. */
export const IDEMPOTENCY_KEY_HEADER = 'idempotency-key';
export const idempotencyKeySchema = z
    .string()
    .trim()
    .min(16, 'idempotency key must be at least 16 characters')
    .max(128)
    .regex(/^[A-Za-z0-9_-]+$/, 'idempotency key must be URL-safe');
/** Completed results remain replayable through ordinary client retry windows. */
export const IDEMPOTENCY_RETENTION_HOURS = 24;
export const IDEMPOTENCY_STATUS = ['IN_PROGRESS', 'COMPLETED'];
export const idempotencyStatusSchema = z.enum(IDEMPOTENCY_STATUS);
//# sourceMappingURL=idempotency.js.map